<template>
  <div class="dashboard-wrap">
    <div class="loader" v-if="isLoading">
      <CSpinner variant="grow" />
    </div>
    <CCard class="mb-0">
      <CCardHeader class="top-header-wrap top-header">
        <p>Date Range</p>
        <CRow>
          <CCol sm="4">
            <CInput
              label="From Date"
              type="date"
              :value="clientvise_fromdate_value"
              id="clientvise_fromdate"
              @input="dateFilter_client"
            />
          </CCol>
          <CCol sm="4">
            <CInput
              label="To Date"
              type="date"
              :value="sitevise_todate_value"
              id="clientvise_todate"
              @input="dateFilter_client"
            />
          </CCol>
          <CCol sm="4">
            <CSelect
              label="Site"
              :options="plantcodeOptions"
              id="plantcodeOptions"
              placeholder="Select Site"
              :value.sync="selectedPantCode"
              v-on:change="fnGetDashboardData()"
            />
            <!-- v-on:change="getShuffledWasteDataFilter()" -->
          </CCol>
        </CRow>
      </CCardHeader>
      <CCardBody>
        <CRow v-if="requestData">
          <CCol sm="4">
            <div class="common-top-card blue-bg">
              <h4 id="traffic" class="card-title mb-0">Total Request</h4>
              <p>
                ({{
                  requestData &&
                  requestData.requestStatus &&
                  requestData.requestStatus.totaL_REQUEST
                }})
              </p>
            </div>
          </CCol>
          <CCol sm="4">
            <div class="common-top-card yellow-bg">
              <h4 id="traffic" class="card-title mb-0">Total Trips</h4>
              <p>
                ({{
                  requestData &&
                  requestData.tripStatus &&
                  requestData.tripStatus.totaL_TRIPS
                }})
              </p>
            </div>
          </CCol>
          <CCol sm="4">
            <div class="common-top-card green-bg">
              <h4 id="traffic" class="card-title mb-0">Total Trips Qty</h4>
              <p>
                ({{
                  requestData &&
                  requestData.tripStatus &&
                  requestData.tripStatus.totaL_TRIPS_QTY
                }})
              </p>
            </div>
          </CCol>
        </CRow>
        <CRow :xs="{ gutter: 2 }" v-if="requestData">
          <CCol sm="2">
            <div class="common-top-card grey-bg">
              <h4 id="traffic" class="card-title mb-0">Request Pending</h4>
              <p>
                ({{
                  requestData &&
                  requestData.requestStatus &&
                  requestData.requestStatus.pending
                }})
              </p>
            </div>
          </CCol>
          <CCol sm="2">
            <div class="common-top-card orange-bg">
              <h4 id="traffic" class="card-title mb-0">Request Approved</h4>
              <p>
                ({{
                  requestData &&
                  requestData.requestStatus &&
                  requestData.requestStatus.approved
                }})
              </p>
            </div>
          </CCol>
          <CCol sm="2">
            <div class="common-top-card blue-bg">
              <h4 id="traffic" class="card-title mb-0">Request Rejected</h4>
              <p>
                ({{
                  requestData &&
                  requestData.requestStatus &&
                  requestData.requestStatus.rejected
                }})
              </p>
            </div>
          </CCol>
          <CCol sm="2">
            <div class="common-top-card green-light-bg">
              <h4 id="traffic" class="card-title mb-0">Vehicle Confirmed</h4>
              <p>
                ({{
                  requestData &&
                  requestData.vehicleStatus &&
                  requestData.vehicleStatus.confirm
                }})
              </p>
            </div>
          </CCol>
          <CCol sm="2">
            <div class="common-top-card sky-blue-bg">
              <h4 id="traffic" class="card-title mb-0">Vehicle In Transist</h4>
              <p>
                ({{
                  requestData &&
                  requestData.vehicleStatus &&
                  requestData.vehicleStatus.iN_TRANSIST
                }})
              </p>
            </div>
          </CCol>
          <CCol sm="2">
            <div class="common-top-card pink-bg">
              <h4 id="traffic" class="card-title mb-0">Vehicle Placed</h4>
              <p>
                ({{
                  requestData &&
                  requestData.vehicleStatus &&
                  requestData.vehicleStatus.placed
                }})
              </p>
            </div>
          </CCol>
        </CRow>

        <CRow>
          <CCol sm="6">
            <div class="common-graph-bg">
              <div id="chart-container" v-on:click="previewGraph"></div>
            </div>
          </CCol>
          <CCol sm="6">
            <!-- <div class="common-graph-bg" v-on:click="previewGraph">
              <p>Avg. Loading Time</p>
              <canvas id="myChart" width="400" height="260"></canvas>
            </div> -->
          </CCol>
        </CRow>
      </CCardBody>
    </CCard>
    <div class="bottom-img">
      <img src="../assets/icons/bottom-img.svg" alt="line" />
    </div>
    <CCard>
      <CCardHeader class="top-header">Account Info</CCardHeader>
      <CCardBody class="acc-body">
        <CRow>
          <CCol sm="6">
            <div class="chart-js-wrap">
              <p>Ageing</p>
              <canvas id="myChartAgeing" width="400" height="220"></canvas>
            </div>
          </CCol>
          <CCol sm="6">
            <div class="avg-payment-wrap">
              <p>Average Payment Days</p>
              <div class="date-wrap">
                <h3>
                  {{
                    requestData &&
                    requestData.requestStatus &&
                    requestData.requestStatus.apd
                  }}
                </h3>
                <p>Days</p>
              </div>
              <h3>Last Month</h3>
            </div>
          </CCol>
        </CRow>
        <CRow>
          <CCol sm="6">
            <div class="common-table-bg">
              <div class="common-top-table">
                <p>Invoice</p>
                <p>Last 5 Invoice</p>
              </div>
              <table>
                <tr>
                  <th>#Invoice</th>
                  <th>Date</th>
                  <th>Amount</th>
                </tr>
                <tr v-for="(item, index) in InvoiceData" :key="index">
                  <td>{{ item.invoiceNo }}</td>
                  <td>{{ item.invoiceDate }}</td>
                  <td>{{ item.invoiceAmount }}</td>
                </tr>
                <!-- <tr>
                  <td>262756</td>
                  <td>19-March-2022</td>
                  <td>₹ 30,000.00</td>
                </tr>
                <tr>
                  <td>262756</td>
                  <td>19-March-2022</td>
                  <td>₹ 30,000.00</td>
                </tr>
                <tr>
                  <td>262756</td>
                  <td>19-March-2022</td>
                  <td>₹ 30,000.00</td>
                </tr>
                <tr>
                  <td>262756</td>
                  <td>19-March-2022</td>
                  <td>₹ 30,000.00</td>
                </tr> -->
              </table>
            </div>
          </CCol>
          <CCol sm="6">
            <div class="common-table-bg">
              <div class="common-top-table">
                <p>Payments</p>
                <p>Last 5 Payments</p>
              </div>
              <table>
                <tr>
                  <!-- <th>#Transaction</th> -->
                  <th>#Invoice</th>
                  <th>Date</th>
                  <th>Amount</th>
                </tr>
                <tr v-for="(item, index) in PaymentData" :key="index">
                  <!-- <td>{{ item.receiptNo }}</td> -->
                  <td>{{ item.receiptNo }}</td>
                  <td>{{ item.receiptDate }}</td>
                  <td>{{ item.receiptAmount }}</td>
                </tr>
                <!-- <tr>
                  <td>262756</td>
                  <td>19-March-2022</td>
                  <td>342756</td>
                  <td>₹ 30,000.00</td>
                </tr>
                <tr>
                  <td>262756</td>
                  <td>19-March-2022</td>
                  <td>342756</td>
                  <td>₹ 30,000.00</td>
                </tr>
                <tr>
                  <td>262756</td>
                  <td>19-March-2022</td>
                  <td>342756</td>
                  <td>₹ 30,000.00</td>
                </tr>
                <tr>
                  <td>262756</td>
                  <td>19-March-2022</td>
                  <td>342756</td>
                  <td>₹ 30,000.00</td>
                </tr> -->
              </table>
            </div>
          </CCol>
        </CRow>
      </CCardBody>
    </CCard>
    <!-- <CCard>
      <CCardHeader class="top-header">Star Bucks</CCardHeader>
      <CCardBody class="acc-body">
        <CRow>
          <CCol sm="12">
            <div class="star-ratings">
              <img src="../assets/icons/Star.svg" alt="stars" />
              <img src="../assets/icons/Star.svg" alt="stars" />
              <img src="../assets/icons/Star.svg" alt="stars" />
              <img src="../assets/icons/Star.svg" alt="stars" />
            </div>
          </CCol>
        </CRow>
      </CCardBody>
    </CCard> -->
    <CCard>
      <CCardHeader class="top-header custom-header"
        >Rate your Experience</CCardHeader
      >
      <CCardBody class="acc-body">
        <CRow>
          <CCol sm="12">
            <div class="rate-exp-wrap">
              <p>Your feedback will help us to serve you better.</p>
              <ul>
                <li class="orange-circle" v-on:click="openFeedbackPopup">
                  <a>1</a>
                </li>
                <li class="orange-circle" v-on:click="openFeedbackPopup">
                  <a>2</a>
                </li>
                <li class="orange-circle" v-on:click="openFeedbackPopup">
                  <a>3</a>
                </li>
                <li class="orange-circle" v-on:click="openFeedbackPopup">
                  <a>4</a>
                </li>
                <li class="blue-circle"><a>5</a></li>
                <li class="blue-circle"><a>6</a></li>
                <li class="blue-circle"><a>7</a></li>
                <li class="green-circle"><a>8</a></li>
                <li class="green-circle"><a>9</a></li>
                <li class="green-circle"><a>10</a></li>
              </ul>
            </div>
          </CCol>
        </CRow>
      </CCardBody>
    </CCard>
    <CModal
      color="danger"
      :title="modalTitle"
      :show.sync="graph1ShowModal"
      size="lg-2"
    >
      <span class="border rounded">Hello Guys</span>
      <!-- {{modalText}} -->
    </CModal>
    <!-- --------------- -->
    <CModal
      color="danger"
      :title="modalTitle"
      :show.sync="feedbackShowModal"
      size="lg-2"
    >
      <CRow>
        <CCol sm="12" class="mb-3">
          <!-- :value="CustomerName" -->
          <CInput label="Remarks" placeholder="Remarks" name="Remarks" />
        </CCol>
      </CRow>
    </CModal>

    <!-- <div class="dashboard-calendar">
     <calendar-view
            :show-date="showDate"
            class="theme-default holiday-us-traditional holiday-us-official">
            <calendar-view-header
                slot="header"
                slot-scope="t"
                :header-props="t.headerProps"
                @input="setShowDate" />
        </calendar-view>
    </div> -->
    <!-- <CCard>
      <CCardBody>
        <CRow>
          <CCol sm="5">
            <h4 id="traffic" class="card-title mb-0">Traffic</h4>
            <div class="small text-muted">November 2017</div>
          </CCol>
          <CCol sm="7" class="d-none d-md-block">
            <CButton color="primary" class="float-right">
              <CIcon name="cil-cloud-download"/>
            </CButton>
            <CButtonGroup class="float-right mr-3">
              <CButton
                color="outline-secondary"
                v-for="(value, key) in ['Day', 'Month', 'Year']"
                :key="key"
                class="mx-0"
                :pressed="value === selected ? true : false"
                @click="selected = value"
              >
                {{value}}
              </CButton>
            </CButtonGroup>
          </CCol>
        </CRow>
        <MainChartExample style="height:300px;margin-top:40px;"/>
      </CCardBody>
      <CCardFooter>
        <CRow class="text-center">
          <CCol md sm="12" class="mb-sm-2 mb-0">
            <div class="text-muted">Visits</div>
            <strong>29.703 Users (40%)</strong>
            <CProgress
              class="progress-xs mt-2"
              :precision="1"
              color="success"
              :value="40"
            />
          </CCol>
          <CCol md sm="12" class="mb-sm-2 mb-0 d-md-down-none">
            <div class="text-muted">Unique</div>
            <strong>24.093 Users (20%)</strong>
            <CProgress
              class="progress-xs mt-2"
              :precision="1"
              color="info"
              :value="20"
            />
          </CCol>
          <CCol md sm="12" class="mb-sm-2 mb-0">
            <div class="text-muted">Pageviews</div>
            <strong>78.706 Views (60%)</strong>
            <CProgress
              class="progress-xs mt-2"
              :precision="1"
              color="warning"
              :value="60"
            />
          </CCol>
          <CCol md sm="12" class="mb-sm-2 mb-0">
            <div class="text-muted">New Users</div>
            <strong>22.123 Users (80%)</strong>
            <CProgress
              class="progress-xs mt-2"
              :precision="1"
              color="danger"
              :value="80"
            />
          </CCol>
          <CCol md sm="12" class="mb-sm-2 mb-0 d-md-down-none">
            <div class="text-muted">Bounce Rate</div>
            <strong>Average Rate (40.15%)</strong>
            <CProgress
              class="progress-xs mt-2"
              :precision="1"
              :value="40"
            />
          </CCol>
        </CRow>
      </CCardFooter>
    </CCard> -->
    <!-- <WidgetsBrand/> -->
    <!-- <CRow>
      <CCol md="12">
        <CCard>
          <CCardHeader>
            Traffic &amp; Sales
          </CCardHeader>
          <CCardBody>
            <CRow>
              <CCol sm="12" lg="6">
                <CRow>
                  <CCol sm="6">
                    <CCallout color="info">
                      <small class="text-muted">New Clients</small><br>
                      <strong class="h4">9,123</strong>
                    </CCallout>
                  </CCol>
                  <CCol sm="6">
                    <CCallout color="danger">
                      <small class="text-muted">Recurring Clients</small><br>
                      <strong class="h4">22,643</strong>
                    </CCallout>
                  </CCol>
                </CRow>
                <hr class="mt-0">
                <div class="progress-group mb-4">
                  <div class="progress-group-prepend">
                    <span class="progress-group-text">
                      Monday
                    </span>
                  </div>
                  <div class="progress-group-bars">
                    <CProgress
                      class="progress-xs"
                      color="info"
                      :value="34"
                    />
                    <CProgress
                      class="progress-xs"
                      color="danger"
                      :value="78"
                    />
                  </div>
                </div>
                <div class="progress-group mb-4">
                  <div class="progress-group-prepend">
                    <span class="progress-group-text">
                      Tuesday
                    </span>
                  </div>
                  <div class="progress-group-bars">
                    <CProgress
                      class="progress-xs"
                      :value="56"
                      color="info"
                    />
                    <CProgress
                      class="progress-xs"
                      :value="94"
                      color="danger"
                    />
                  </div>
                </div>
                <div class="progress-group mb-4">
                  <div class="progress-group-prepend">
                    <span class="progress-group-text">
                      Wednesday
                    </span>
                  </div>
                  <div class="progress-group-bars">
                    <CProgress
                      class="progress-xs"
                      :value="12"
                      color="info"
                    />
                    <CProgress
                      class="progress-xs"
                      :value="67"
                      color="danger"
                    />
                  </div>
                </div>
                <div class="progress-group mb-4">
                  <div class="progress-group-prepend">
                    <span class="progress-group-text">
                      Thursday
                    </span>
                  </div>
                  <div class="progress-group-bars">
                    <CProgress
                      class="progress-xs"
                      :value="43"
                      color="info"
                    />
                    <CProgress
                      class="progress-xs"
                      :value="91"
                      color="danger"
                    />
                  </div>
                </div>
                <div class="progress-group mb-4">
                  <div class="progress-group-prepend">
                    <span class="progress-group-text">
                      Friday
                    </span>
                  </div>
                  <div class="progress-group-bars">
                    <CProgress
                      class="progress-xs"
                      :value="22"
                      color="info"
                    />
                    <CProgress
                      class="progress-xs"
                      :value="73"
                      color="danger"
                    />
                  </div>
                </div>
                <div class="progress-group mb-4">
                  <div class="progress-group-prepend">
                    <span class="progress-group-text">
                      Saturday
                    </span>
                  </div>
                  <div class="progress-group-bars">
                    <CProgress
                      class="progress-xs"
                      :value="53"
                      color="info"
                    />
                    <CProgress
                      class="progress-xs"
                      :value="82"
                      color="danger"
                    />
                  </div>
                </div>
                <div class="progress-group mb-4">
                  <div class="progress-group-prepend">
                    <span class="progress-group-text">
                      Sunday
                    </span>
                  </div>
                  <div class="progress-group-bars">
                    <CProgress
                      class="progress-xs"
                      :value="9"
                      color="info"
                    />
                    <CProgress
                      class="progress-xs"
                      :value="69"
                      color="danger"
                    />
                  </div>
                </div>
                <div class="legend text-center">
                  <small>
                    <sup><CBadge shape="pill" color="info">&nbsp;</CBadge></sup>
                    New clients
                    &nbsp;&nbsp;
                    <sup><CBadge shape="pill" color="danger">&nbsp;</CBadge></sup>
                    Recurring clients
                  </small>
                </div>
              </CCol>
              <CCol sm="12" lg="6">
                <CRow>
                  <CCol sm="6">
                    <CCallout color="warning">
                      <small class="text-muted">Pageviews</small><br>
                      <strong class="h4">78,623</strong>
                    </CCallout>
                  </CCol>
                  <CCol sm="6">
                    <CCallout color="success">
                      <small class="text-muted">Organic</small><br>
                      <strong class="h4">49,123</strong>
                    </CCallout>
                  </CCol>
                </CRow>
                <hr class="mt-0">
                <ul class="horizontal-bars type-2">
                  <div class="progress-group">
                    <div class="progress-group-header">
                      <CIcon name="cil-user" class="progress-group-icon"/>
                      <span class="title">Male</span>
                      <span class="ml-auto font-weight-bold">43%</span>
                    </div>
                    <div class="progress-group-bars">
                      <CProgress
                        class="progress-xs"
                        :value="43"
                        color="warning"
                      />
                    </div>
                  </div>
                  <div class="progress-group mb-5">
                    <div class="progress-group-header">
                      <CIcon name="cil-user-female" class="progress-group-icon"/>
                      <span class="title">Female</span>
                      <span class="ml-auto font-weight-bold">37%</span>
                    </div>
                    <div class="progress-group-bars">
                      <CProgress
                        class="progress-xs"
                        :value="37"
                        color="warning"
                      />
                    </div>
                  </div>
                  <div class="progress-group">
                    <div class="progress-group-header">
                      <CIcon name="cil-globe-alt" class="progress-group-icon"/>
                      <span class="title">Organic Search</span>
                      <span class="ml-auto font-weight-bold">
                        191,235 <span class="text-muted small">(56%)</span>
                      </span>
                    </div>
                    <div class="progress-group-bars">
                      <CProgress
                        class="progress-xs"
                        :value="56"
                        color="success"
                      />
                    </div>
                  </div>
                  <div class="progress-group">
                    <div class="progress-group-header">
                      <CIcon
                        name="cib-facebook"
                        height="17"
                        class="progress-group-icon"
                      />
                      <span class="title">Facebook</span>
                      <span class="ml-auto font-weight-bold">
                        51,223 <span class="text-muted small">(15%)</span>
                      </span>
                    </div>
                    <div class="progress-group-bars">
                      <CProgress
                        class="progress-xs"
                        :value="15"
                        color="success"
                      />
                    </div>
                  </div>
                  <div class="progress-group">
                    <div class="progress-group-header">
                      <CIcon
                        name="cib-twitter"
                        height="17"
                        class="progress-group-icon"
                      />
                      <span class="title">Twitter</span>
                      <span class="ml-auto font-weight-bold">
                        37,564 <span class="text-muted small">(11%)</span>
                      </span>
                    </div>
                    <div class="progress-group-bars">
                      <CProgress
                        class="progress-xs"
                        :value="11"
                        color="success"
                      />
                    </div>
                  </div>
                  <div class="progress-group">
                    <div class="progress-group-header">
                      <CIcon
                        name="cib-linkedin"
                        height="17"
                        class="progress-group-icon"
                      />
                      <span class="title">LinkedIn</span>
                      <span class="ml-auto font-weight-bold">
                        27,319 <span class="text-muted small">&nbsp;(8%)</span>
                      </span>
                    </div>
                    <div class="progress-group-bars">
                      <CProgress
                        class="progress-xs"
                        :value="8"
                        color="success"
                      />
                    </div>
                  </div>
                  <div class="divider text-center">
                    <CButton color="link" size="sm" class="text-muted">
                      <CIcon name="cil-options"/>
                    </CButton>
                  </div>
                </ul>
              </CCol>
            </CRow>
            <br/>
            <CDataTable
              class="mb-0 table-outline"
              hover
              :items="tableItems"
              :fields="tableFields"
              head-color="light"
              no-sorting
            >
              <td slot="avatar" class="text-center" slot-scope="{item}">
                <div class="c-avatar">
                  <img :src="item.avatar.url" class="c-avatar-img" alt="">
                  <span
                    class="c-avatar-status"
                    :class="`bg-${item.avatar.status || 'secondary'}`"
                  ></span>
                </div>
              </td>
              <td slot="user" slot-scope="{item}">
                <div>{{item.user.name}}</div>
                <div class="small text-muted">
                  <span>
                    <template v-if="item.user.new">New</template>
                    <template v-else>Recurring</template>
                  </span> | Registered: {{item.user.registered}}
                </div>
              </td>
              <td
                slot="country"
                slot-scope="{item}"
                class="text-center"
              >
                <CIcon
                  :name="item.country.flag"
                  height="25"
                />
              </td>
              <td slot="usage" slot-scope="{item}">
                <div class="clearfix">
                  <div class="float-left">
                    <strong>{{item.usage.value}}%</strong>
                  </div>
                  <div class="float-right">
                    <small class="text-muted">{{item.usage.period}}</small>
                  </div>
                </div>
                <CProgress
                  class="progress-xs"
                  v-model="item.usage.value"
                  :color="color(item.usage.value)"
                />
              </td>
              <td
                slot="payment"
                slot-scope="{item}"
                class="text-center"
              >
                <CIcon
                  :name="item.payment.icon"
                  height="25"
                />
              </td>
              <td slot="activity" slot-scope="{item}">
                <div class="small text-muted">Last login</div>
                <strong>{{item.activity}}</strong>
              </td>
            </CDataTable>
          </CCardBody>
        </CCard>
      </CCol>
    </CRow> -->
  </div>
</template>

<script>
//import MainChartExample from './charts/MainChartExample'
import WidgetsDropdown from "./widgets/WidgetsDropdown";
//import WidgetsBrand from './widgets/WidgetsBrand'
import Chart from "chart.js/auto";
import { CalendarView, CalendarViewHeader } from "vue-simple-calendar";
require("vue-simple-calendar/static/css/default.css");
require("vue-simple-calendar/static/css/holidays-us.css");
import Vue from "vue";
import VueFusionCharts from "vue-fusioncharts";
import FusionCharts from "fusioncharts";
import Column2D from "fusioncharts/fusioncharts.charts";
import FusionTheme from "fusioncharts/themes/fusioncharts.theme.fusion";

Vue.use(VueFusionCharts, FusionCharts, Column2D, FusionTheme);
import axios from "axios";
export default {
  // name: "Dashboard",
  components: {
    //MainChartExample,
    WidgetsDropdown,
    //WidgetsBrand,
    CalendarView,
    CalendarViewHeader,
  },
  data() {
    return {
      showDate: new Date(),
      selected: "Month",
      countValue: {},
      graph1ShowModal: false,
      feedbackShowModal: false,
      InvoiceData: [],
      PaymentData: [],
      isLoading: false,
      requestData: {},
      cplantcodeOptions: [],
      siteArr: [],
      Plant_Code: 0,
      items: [],
      addcondition: "",
      clientvise_fromdate_value: "",
      sitevise_todate_value: "",
      selectedPantCode: null,
    };
  },
  mounted() {
    // for date rannge header
    var self = this;
    // self.fnGetWastList();
    var d = new Date();
    var month = d.getMonth() + 1;
    var day = d.getDate();

    var today =
      d.getFullYear() +
      "-" +
      (month < 10 ? "0" : "") +
      month +
      "-" +
      (day < 10 ? "0" : "") +
      day;
    self.sitevise_todate_value = today;

    d.setDate(d.getDate() - 7);
    var month = d.getMonth() + 1;
    var day = d.getDate();

    var firstdate =
      d.getFullYear() +
      "-" +
      (month < 10 ? "0" : "") +
      month +
      "-" +
      (day < 10 ? "0" : "") +
      day;
    self.clientvise_fromdate_value = firstdate;

    // for get sapsite list
    var token = localStorage.getItem("auth");
    var Session_User_Id = JSON.parse(localStorage.getItem("User_Id"));
    var requestInfo = {
      Token: token,
      Session_User_Id: Session_User_Id,
    };
    var data = JSON.stringify(requestInfo);
    var config = {
      method: "post",
      url: apiURL + "MasterData/GetSapSites",
      headers: {
        "Content-Type": "application/json",
      },
      data: data,
    };
    this.isLoading = true;
    axios(config).then((result) => {
      if (result.data.status_code == 200) {
        var obj = result.data.response;
        var siteOptionsArr = obj;

        this.siteArr = obj;
        var siteSingleArr = [];
        var selArr = siteOptionsArr.find(function (jsonitem, i) {
          siteSingleArr.push(jsonitem.Plant_Name);
        });
        this.plantcodeOptions = siteSingleArr;
        var self1 = self;
        var Session_User_Id = JSON.parse(localStorage.getItem("User_Id"));
        // console.log("this.plantcodeOptions", siteOptionsArr[0].Plant_Code);
        self1.selectedPantCode = siteOptionsArr[0].Plant_Name;
        console.log("self1.selectedPantCode-", self1.selectedPantCode);
        const requestInfo = {
          customerID: Session_User_Id,
          plantCode: siteOptionsArr[0].Plant_Code,
          type: "Summary",
          fromDate: self1.clientvise_fromdate_value,
          toDate: self1.sitevise_todate_value,
        };
        const requestInvoiceInfo = {
          customerID: Session_User_Id,
          plantCode: siteOptionsArr[0].Plant_Code,
          type: "INVOICE",
          fromDate: self1.clientvise_fromdate_value,
          toDate: self1.sitevise_todate_value,
        };
        const requestPaymentInfo = {
          customerID: Session_User_Id,
          plantCode: siteOptionsArr[0].Plant_Code,
          type: "RECEIPT",
          fromDate: self1.clientvise_fromdate_value,
          toDate: self1.sitevise_todate_value,
        };
        var data = JSON.stringify(requestInfo);
        const newConfig = {
          method: "POST",
          url: apiURL + "Customer/DashBoardInfo",
          headers: { "Content-Type": "application/json" },
          data: data,
        };
        this.isLoading = true;
        axios(newConfig)
          .then((result) => {
            this.requestData = result.data.response;
            this.fnInvoiceListData(requestInvoiceInfo);
            this.fnPaymentsListData(requestPaymentInfo);
            // loading efficiancty chart
            // this.myChart1;

            setTimeout(() => {
              FusionCharts.ready(function () {
                // chart instance
                console.log(
                  "this.requestData?.requestStatus----",
                  result.data.response.requestStatus.loadingEfficency
                );
                var chart = new FusionCharts({
                  type: "angulargauge",
                  renderAt: "chart-container", // container where chart will render
                  width: "420",
                  height: "300",
                  dataFormat: "json",
                  dataSource: {
                    chart: {
                      caption: "Loading Effiency",
                      lowerlimit: "0",
                      upperlimit: "100",
                      showvalue: "1",
                      numbersuffix: "%",
                      theme: "fusion",
                      showtooltip: "0",
                    },
                    colorrange: {
                      color: [
                        {
                          minvalue: "0",
                          maxvalue: "50",
                          code: "#F2726F",
                        },
                        {
                          minvalue: "50",
                          maxvalue: "75",
                          code: "#FFC533",
                        },
                        {
                          minvalue: "75",
                          maxvalue: "100",
                          code: "#62B58F",
                        },
                      ],
                    },
                    dials: {
                      dial: [
                        {
                          // value: "55",
                          value:
                            result.data.response.requestStatus.loadingEfficency,
                        },
                      ],
                    },
                  },
                }).render();
              });
            }, 400);
            // for Ageing chart---------------------------------------
            const ageingChartRender = document.getElementById("myChartAgeing");
            const { dayS030, dayS3160, dayS6190, daysgrT90 } =
              this.requestData.ageingStatus.__ob__.value;

            setTimeout(() => {
              const chartAgeing1 = new Chart(ageingChartRender, {
                type: "line",
                data: {
                  labels: ["0-30 Days", "31-60 Days", "61-90 Days", ">91 Days"],
                  datasets: [
                    {
                      label: "",
                      // data: [0, 50, 100, 150, 200],
                      data: [dayS030, dayS3160, dayS6190, daysgrT90],
                      fill: false,
                      tension: 0.1,
                      borderColor: "#017efa",
                      borderWidth: 3,
                    },
                  ],
                },
                options: {
                  scales: {
                    x: {
                      display: true,
                      title: {
                        display: true,
                        // text: "Date",
                        color: "#9f9fa8",
                      },
                    },
                    y: {
                      beginAtZero: true,
                      display: true,
                      title: {
                        display: true,
                        // text: "Time",
                        color: "#9f9fa8",
                      },
                    },
                  },
                },
              });
              chartAgeing1.render();
              // chartAgeing1.destroy();
            }, 400);
            this.isLoading = false;
          })
          .catch((error) => {
            this.isLoading = false;
            this.$swal.fire({
              icon: "error",
              title: "Oops...",
              text: "Something went wrong!",
            });
          });
      } else {
        this.$swal.fire({
          icon: "error",
          title: "Oops...",
          text: result.data.message,
        });
      }
    });

    this.countValue = {
      Total_Request: "10",
      Total_Trips: "20",
      Total_Trips_Qty: "20",
      Pending_Request: "20",
      Approved_Request: "20",
      Rejected_Request: "20",
      Confirmed_Vehicle: "10",
      Transist_Vehicle: "10",
      Placed_Vehicle: "20",
      Loding_Effiency: "",
      Loading_time: "",
      "0-21": "15",
      "22-45": "15",
      "46-60": "15",
      "61-90": "15",
      ">90": "15",
      Average_Payments_Days: "20",
    };
    // for invoice
    // this.InvoiceData = [
    //   {
    //     __metadata: {
    //       id: "http://srveccqa.luthraindia.com:8000/sap/opu/odata/sap/ZCUSTOMER_SD_SRV/VBAKSet('1806004042')",
    //       uri: "http://srveccqa.luthraindia.com:8000/sap/opu/odata/sap/ZCUSTOMER_SD_SRV/VBAKSet('1806004042')",
    //       type: "ZCUSTOMER_SD_SRV.VBAK",
    //     },
    //     Invoice_No: "1806004042",
    //     Date: "01-04-2022",
    //     Amount: "24555",
    //   },
    //   {
    //     __metadata: {
    //       id: "http://srveccqa.luthraindia.com:8000/sap/opu/odata/sap/ZCUSTOMER_SD_SRV/VBAKSet('1806004064')",
    //       uri: "http://srveccqa.luthraindia.com:8000/sap/opu/odata/sap/ZCUSTOMER_SD_SRV/VBAKSet('1806004064')",
    //       type: "ZCUSTOMER_SD_SRV.VBAK",
    //     },
    //     Invoice_No: "1806004064",
    //     Date: "01-04-2022",
    //     Amount: "51555",
    //   },
    // ];
    // this.PaymentData = [
    //   {
    //     __metadata: {
    //       id: "http://srveccqa.luthraindia.com:8000/sap/opu/odata/sap/ZCUSTOMER_SD_SRV/VBAKSet('1806004042')",

    //       uri: "http://srveccqa.luthraindia.com:8000/sap/opu/odata/sap/ZCUSTOMER_SD_SRV/VBAKSet('1806004042')",

    //       type: "ZCUSTOMER_SD_SRV.VBAK",
    //     },

    //     Payment_Receipt: "1806004042",

    //     Date: "01-04-2022",

    //     Invoice: "1906004042",

    //     Amount: "24555",
    //   },

    //   {
    //     __metadata: {
    //       id: "http://srveccqa.luthraindia.com:8000/sap/opu/odata/sap/ZCUSTOMER_SD_SRV/VBAKSet('1806004064')",

    //       uri: "http://srveccqa.luthraindia.com:8000/sap/opu/odata/sap/ZCUSTOMER_SD_SRV/VBAKSet('1806004064')",

    //       type: "ZCUSTOMER_SD_SRV.VBAK",
    //     },

    //     Payment_Receipt: "1806004064",

    //     Date: "01-04-2022",

    //     Invoice: "9996004042",

    //     Amount: "51555",
    //   },
    // ];

    // const ctx = document.getElementById("myChart");
    // const myChart = new Chart(ctx, {
    //   type: "line",
    //   data: {
    //     labels: ["1 Mar", "2 Mar", "3 Mar", "4 Mar", "5 Mar", "6 Mar", "7 Mar"],
    //     datasets: [
    //       {
    //         label: "",
    //         data: [1, 2, 3, 4, 5, 6, 7],
    //         fill: false,
    //         tension: 0.1,
    //         borderColor: "#017efa",
    //         borderWidth: 3,
    //       },
    //     ],
    //   },
    //   options: {
    //     scales: {
    //       x: {
    //         display: true,
    //         title: {
    //           display: true,
    //           text: "Date",
    //           color: "#9f9fa8",
    //         },
    //       },
    //       y: {
    //         beginAtZero: true,
    //         display: true,
    //         title: {
    //           display: true,
    //           text: "Time",
    //           color: "#9f9fa8",
    //         },
    //       },
    //     },
    //   },
    // });
    // myChart;

    // ------------------------------
  },
  methods: {
    dateFilter_client() {
      console.log("date filter");
      // this.getShuffledWasteDataFilter();
      this.fnGetDashboardData();
    },

    previewGraph() {
      // alert(templateHTML);
      this.graph1ShowModal = true;
    },
    openFeedbackPopup() {
      // alert(templateHTML);
      this.feedbackShowModal = true;
    },
    setShowDate(d) {
      this.showDate = d;
    },
    color(value) {
      let $color;
      if (value <= 25) {
        $color = "info";
      } else if (value > 25 && value <= 50) {
        $color = "success";
      } else if (value > 50 && value <= 75) {
        $color = "warning";
      } else if (value > 75 && value <= 100) {
        $color = "danger";
      }
      return $color;
    },

    // Call dashboard API
    fnGetDashboardData() {
      let chartStatus = Chart.getChart("myChartAgeing"); // <canvas> id
      if (chartStatus != undefined) {
        chartStatus.destroy();
        //(or)
        // chartStatus.clear();
      }
      var Session_User_Id = JSON.parse(localStorage.getItem("User_Id"));
      var value = $("#plantcodeOptions").val();
      var siteOptionsArr = this.siteArr;
      var Plant_Code = "";
      var selArr = siteOptionsArr.find(function (jsonitem, i) {
        if (value == jsonitem.Plant_Name) {
          Plant_Code = jsonitem.Plant_Code;
          //console.log(Plant_Code);
        }
      });
      var firstdate = $("#clientvise_fromdate").val();
      var today = $("#clientvise_todate").val();
      const requestInfo = {
        customerID: Session_User_Id,
        plantCode: Plant_Code,
        type: "Summary",
        fromDate: firstdate,
        toDate: today,
      };
      const requestInvoiceInfo = {
        customerID: Session_User_Id,
        plantCode: Plant_Code,
        type: "Invoice",
        fromDate: firstdate,
        toDate: today,
      };
      const requestPaymentInfo = {
        customerID: Session_User_Id,
        plantCode: Plant_Code,
        type: "RECEIPT",
        fromDate: firstdate,
        toDate: today,
      };
      var data = JSON.stringify(requestInfo);
      const newConfig = {
        method: "POST",
        url: apiURL + "Customer/DashBoardInfo",
        headers: { "Content-Type": "application/json" },
        data: data,
      };

      this.isLoading = true;
      axios(newConfig)
        .then((result) => {
          this.requestData = result.data.response;
          // for Ageing chart---------------------------------------
          this.fnInvoiceListData(requestInvoiceInfo);
          this.fnPaymentsListData(requestPaymentInfo);
          // loading efficiancty chart
          // myChartAgeing1;

          setTimeout(() => {
            FusionCharts.ready(function () {
              // chart instance
              console.log(
                "this.requestData?.requestStatus----",
                result.data.response.requestStatus.loadingEfficency
              );
              var chart = new FusionCharts({
                type: "angulargauge",
                renderAt: "chart-container", // container where chart will render
                width: "420",
                height: "300",
                dataFormat: "json",
                dataSource: {
                  chart: {
                    caption: "Loading Effiency",
                    lowerlimit: "0",
                    upperlimit: "100",
                    showvalue: "1",
                    numbersuffix: "%",
                    theme: "fusion",
                    showtooltip: "0",
                  },
                  colorrange: {
                    color: [
                      {
                        minvalue: "0",
                        maxvalue: "50",
                        code: "#F2726F",
                      },
                      {
                        minvalue: "50",
                        maxvalue: "75",
                        code: "#FFC533",
                      },
                      {
                        minvalue: "75",
                        maxvalue: "100",
                        code: "#62B58F",
                      },
                    ],
                  },
                  dials: {
                    dial: [
                      {
                        // value: "55",
                        value:
                          result.data.response.requestStatus.loadingEfficency,
                      },
                    ],
                  },
                },
              }).render();
            });
          }, 400);
          // for Ageing chart---------------------------------------
          const setAgeingChartRender = document.getElementById("myChartAgeing");
          const { dayS030, dayS3160, dayS6190, daysgrT90 } =
            this.requestData.ageingStatus.__ob__.value;
          console.log(
            "dayS030, dayS3160, dayS6190, daysgrT90----",
            dayS030,
            dayS3160,
            dayS6190,
            daysgrT90
          );
          setTimeout(() => {
            const ageingChartRender1 = new Chart(setAgeingChartRender, {
              type: "line",
              data: {
                labels: ["0-30 Days", "31-60 Days", "61-90 Days", ">91 Days"],
                datasets: [
                  {
                    label: "",
                    // data: [0, 50, 100, 150, 200],
                    data: [dayS030, dayS3160, dayS6190, daysgrT90],
                    fill: false,
                    tension: 0.1,
                    borderColor: "#017efa",
                    borderWidth: 3,
                  },
                ],
              },
              options: {
                scales: {
                  x: {
                    display: true,
                    title: {
                      display: true,
                      // text: "Date",
                      color: "#9f9fa8",
                    },
                  },
                  y: {
                    beginAtZero: true,
                    display: true,
                    title: {
                      display: true,
                      // text: "Time",
                      color: "#9f9fa8",
                    },
                  },
                },
              },
            });
            ageingChartRender1.render();
          }, 400);
          this.isLoading = false;
        })
        .catch((error) => {
          this.isLoading = false;
          this.$swal.fire({
            icon: "error",
            title: "Oops...",
            text: "Something went wrong!",
          });
        });
    },

    // invoicelist
    fnInvoiceListData(getRequestInvoiceInfo) {
      var data = JSON.stringify(getRequestInvoiceInfo);
      const newConfig = {
        method: "POST",
        url: apiURL + "Customer/DashBoardInfo",
        headers: { "Content-Type": "application/json" },
        data: data,
      };
      // this.isLoading = true;
      axios(newConfig)
        .then((result) => {
          this.InvoiceData = result.data.response.invoiceInfoList;
          // this.isLoading = false;
          console.log("InvoiceData---", this.InvoiceData);
        })
        .catch((error) => {
          this.isLoading = false;
          this.$swal.fire({
            icon: "error",
            title: "Oops...",
            text: "Something went wrong!",
          });
        });
    },

    // Paymentslist
    fnPaymentsListData(getRequestPaymentInfo) {
      var data = JSON.stringify(getRequestPaymentInfo);
      const newConfig = {
        method: "POST",
        url: apiURL + "Customer/DashBoardInfo",
        headers: { "Content-Type": "application/json" },
        data: data,
      };
      // this.isLoading = true;
      axios(newConfig)
        .then((result) => {
          this.PaymentData = result.data.response.paymentInfoList;
          // this.isLoading = false;
          console.log("PaymentData---", this.PaymentData);
        })
        .catch((error) => {
          this.isLoading = false;
          this.$swal.fire({
            icon: "error",
            title: "Oops...",
            text: "Something went wrong!",
          });
        });
    },
  },
};
</script>
